export default __webpack_public_path__ + "static/media/full-moon.8423cc64.svg";